export default {
  title: 'Mis niets!',
  description: 'Zet meldingen aan om op de hoogte te blijven van je bestelling.',
  buttons: {
    enable: 'Inschakelen',
  },
};
